
// DEBUG
var DEBUG_AJAX_DELAY = 1;

// Config
var ajaxLockEndpoint   = '/admin/ajax/lock';
var ajaxUnlockEndpoint = '/admin/ajax/unlock';

var busyClass = 'busy';


//
// Lock Screen Controller
//

module.exports = function LockScreenController ($page, $$) {

  var $form    = $$('form');
  var pinInput = getWidgetAtDom($$('[data-widget="pin-input"]'));

  function success (redirect) {
    log('ok', arguments);
    pinInput.accept();
    window.location = redirect;
  }

  function failure () {
    pinInput.reject();
  }

  document.addEventListener('keypress', function (event) {
    pinInput.inject(event.key);
  });

  pinInput.onPin(function (pin) {
    pinInput.busy(true);

    $.ajax({
      type: $form.attr('method'),
      url: $form.attr('action'),
      data: { pin: pin },
      success: function (res) {
        if (res.is_error) {
          failure(res.reason);
        } else {
          success(res.value);
        }
      },
      error: function () {
        failure("Ajax error");
      }
    });
  });

};


